import { createSlice } from '@reduxjs/toolkit';

const now = new Date();

// Default tag selection of each tab. The tags of one group are alternatives, tags of different
// groups must all hold (active + fresh = active AND fresh).
export const DEFAULT_TAGS = {
  calendar: ['active'],
  holes: ['active', 'pf-fresh', 'pf-semifresh'],
  anomalies: [],
};

const slice = createSlice({
  name: 'syncMonitor',
  initialState: {
    selectedCenters: [],
    year: now.getFullYear(),
    month: now.getMonth() + 1,
    view: 'year',
    drawerOpen: false,
    drawerCenter: null,
    drawerDate: null,
    statusFilter: null,
    globalSelectedDate: null,
    tags: {
      calendar: [...DEFAULT_TAGS.calendar],
      holes: [...DEFAULT_TAGS.holes],
      anomalies: [...DEFAULT_TAGS.anomalies],
    },
  },
  reducers: {
    setSelectedCenters: (state, { payload }) => {
      state.selectedCenters = payload;
    },
    setYear: (state, { payload }) => {
      state.year = payload;
    },
    setMonth: (state, { payload }) => {
      state.month = payload;
    },
    setView: (state, { payload }) => {
      state.view = payload;
    },
    openDayDrawer: (state, { payload: { centerId, date } }) => {
      state.drawerOpen = true;
      state.drawerCenter = centerId;
      state.drawerDate = date;
    },
    closeDayDrawer: (state) => {
      state.drawerOpen = false;
      state.drawerCenter = null;
      state.drawerDate = null;
    },
    setStatusFilter: (state, { payload }) => {
      state.statusFilter = payload;
    },
    clearStatusFilter: (state) => {
      state.statusFilter = null;
    },
    setTags: (state, { payload: { tab, tags } }) => {
      state.tags[tab] = tags;
    },
    resetTags: (state, { payload: tab }) => {
      state.tags[tab] = [...DEFAULT_TAGS[tab]];
    },
    setGlobalSelectedDate: (state, { payload }) => {
      state.globalSelectedDate = payload;
    },
    clearGlobalSelectedDate: (state) => {
      state.globalSelectedDate = null;
    },
  },
});

export const {
  setSelectedCenters,
  setYear,
  setMonth,
  setView,
  openDayDrawer,
  closeDayDrawer,
  setStatusFilter,
  clearStatusFilter,
  setTags,
  resetTags,
  setGlobalSelectedDate,
  clearGlobalSelectedDate,
} = slice.actions;

export default slice.reducer;

export const selectSyncMonitor = (state) => state.syncMonitor;
